import React, { useEffect, useState } from 'react';
import { api } from '@/lib/db';
import { useToast } from '@/contexts/ToastContext';
import { Card, Button, Input } from '@/components/ui/Components';
import SafeIcon from '@/common/SafeIcon';

const SiteSettings = () => {
  const { addToast } = useToast();
  const [logoUrl, setLogoUrl] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.getConfig().then(cfg => {
      setLogoUrl(cfg.logo_url || '');
    });
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.updateConfig({ logo_url: logoUrl });
      addToast('Beállítások mentve! Frissítsd az oldalt a változás megtekintéséhez.', 'success');
    } catch (err) {
      addToast(err.message, 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div>
        <h1 className="text-3xl font-black text-gray-900">Rendszer beállítások</h1>
        <p className="text-gray-500">Az oldal megjelenési beállításai.</p>
      </div>

      <Card className="p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <SafeIcon name="Image" className="w-5 h-5 text-blue-600" /> Sidebar logó
        </h3>
        <p className="text-sm text-gray-500 mb-4">
          Add meg a logó URL-jét. Ha üres, a "SocialCard Review" szöveg jelenik meg. A képet tárold valahol (pl. a szerveren, vagy egy CDN-en) és másold be a közvetlen hivatkozást.
        </p>
        <form onSubmit={handleSave} className="space-y-4">
          <Input
            label="Logó URL"
            placeholder="https://domain.hu/logo.png"
            value={logoUrl}
            onChange={e => setLogoUrl(e.target.value)}
          />

          {logoUrl && (
            <div className="p-4 bg-gray-900 rounded-xl flex items-center gap-3">
              <p className="text-xs text-gray-400 mr-2">Előnézet:</p>
              <img
                src={logoUrl}
                alt="Logo előnézet"
                className="h-10 w-auto object-contain"
                onError={e => { e.target.style.display = 'none'; }}
              />
            </div>
          )}

          <div className="pt-2 text-sm text-gray-500 bg-blue-50 p-4 rounded-lg border border-blue-100">
            <p className="font-semibold text-blue-800 mb-1">Tipp: logó feltöltése a szerverre</p>
            <p>Töltsd fel a logó fájlt SFTP-vel a <span className="font-mono text-xs">/var/www/reviewfilter-saas-platform-development/dist/</span> mappába, majd az URL:</p>
            <p className="font-mono text-xs mt-1">https://review.socialcard.hu/logo.png</p>
          </div>

          <div className="flex justify-end">
            <Button type="submit" disabled={saving}>
              {saving ? 'Mentés...' : 'Beállítások mentése'}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default SiteSettings;
